module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure-nxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("Dear reader, I don’t know where you are in your life’s journey, but I’m pretty sure you will find many quotes in "), _c('span', {
    staticClass: "BROTHERregularitalic"
  }, [_vm._v("Hey! It’s Your Day")]), _c('span', {
    staticClass: "CharOverride-16"
  }), _vm._v("that will inspire you every day. You have a whole book ahead of you, so I’ll close with a short, affirming quote, which has guided me for many years:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("Nothing is worth more than this"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("day.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—Johann Wolfgang von Goethe")]), _vm._v(" "), _c('p', {
    staticClass: "White_Quote ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("June")]), _c('span', {
    staticClass: "noBreak CharOverride-17"
  }), _c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("Cotner")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white ParaOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "http://www.junecotner.com",
      "target": "_blank"
    }
  }, [_vm._v("www.junecotner.com")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "mailto:june@junecotner.com"
    }
  }, [_vm._v("june@junecotner.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white ParaOverride-7"
  }, [_vm._v("Facebook: @June.Cotner.Books (author page)"), _c('br'), _vm._v("LinkedIn: "), _c('a', {
    attrs: {
      "href": "http://www.linkedin.com/in/junecotner",
      "target": "_blank"
    }
  }, [_vm._v("www.linkedin.com/in/junecotner")]), _c('br'), _vm._v("Instagram: @JuneCotner"), _c('br'), _vm._v("Twitter: @JuneCotner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ce1692c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039446.vue
// module id = 78
// module chunks = 0